<template>
  <div class="cover-video-container" ref="cover-video-container">
    <div v-if="article" class="video-player" :id="`container_${uniqVideoId}`" :ref="uniqVideoId">
      <VideoMcpViewer :regular-player="true" :mcp-id="article.story.mcp_cover_video" :video-uniq-id="uniqVideoId" :play-video="playVideo" class="container-video-multimedia" :bg-loop="true" />
    </div>
    <div class="container-cover" v-if="article">
      <div class="container-cover__content">
        <div class="container-cover__image" >
          <div>
            <h1 class="d-none">{{ article.story.title }}</h1>
            <img :src="article.story.title_cover" :alt="article.story.title_cover" />
            <div class="text-white text-center authors mb-3" v-html="article.story.authors"></div>
            <div class="text-white text-center date-article mb-3" v-html="article.story.published"></div>
            <div class="slide-controls">
              <div class="slide-arrow-down"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
              </svg></div>
          </div>
          </div>
        </div>

        <div>
          <div class="text-center cover-credits">
            <div class="excerpt text-white" v-html="article.story.excerpt"></div>
          </div>        
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translatey(7vh);
    }

    to {
      opacity: 1;
      transform: translateY(0vh);
    }
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translatey(0vh);
    }

    to {
      opacity: 1;
      transform: translateY(10vh);
    }
  }

  .cover-video-container {
    position: relative;
    width: 100%;
    height: 270vh;
    background: #000;

    .cover-credits {
      display: flex;
      align-items: center;
      height: 100vh;
      max-width: 720px;
      margin: 0 auto;
    }

    .video-player {
      position: sticky;
      top: 0;
      width: 100%;
      height: 100vh;
    }

    .authors {
      font: 300 12px 'Lato', sans-serif;
      position: absolute;
      width: 100%;
      text-align: center;
      bottom: 20vh;
      text-shadow: 0px 0px 4px #000;
      text-transform: uppercase;
    }

    .date-article {
      font: 300 12px 'Lato', sans-serif;
      position: absolute;
      width: 100%;
      text-align: center;
      bottom: 15vh;
      text-shadow: 0px 0px 4px #000;
      text-transform: uppercase;
    }

    .excerpt {
      font: normal 21px/1.3 'Roboto', sans-serif;
      margin-top: 15vh;
      text-shadow: 0px 0px 4px #000;
    }

    .slide-controls {
      position: absolute;
      width: 100%;
      bottom: 15vh;
      text-align: center;

      .slide-arrow-down {
        color: #fff;
        opacity: 0;
        top: 0;
        animation-name: slideDown;
        animation-duration: 1.25s; /* or: Xms */
        animation-iteration-count: infinite;
        animation-timing-function: ease-in-out;
      }
    }

    .container-cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
      padding-bottom: 25vh;
      transform: translatey(0vh) !important;

      animation-name: slideUp;
      animation-duration: 1.25s; /* or: Xms */
      animation-iteration-count: 1;
      animation-timing-function: ease-in-out;

      &__content {
        width: 100%;
        max-width: 720px;
        margin: 0 auto;
      }

      &__image {
        position: relative;
        display: flex;
        align-items: center;
        min-height: 100vh;
        img {
          width: 100%;
        }
      }
    }

    .jwplayer {
      position: sticky;
      top: 0;
    }
  }
</style>

<script>

  import VideoMcpViewer from '@/components/VideoMcpViewer.vue'

  export  default {
    name: 'CoverVideo',
    props: {
      article: {
        type: Object
      }
    },
    data() {
      return {
        playVideo: true,
        uniqVideoId: `component_video_${this._uid}`
      }
    },
    components: {
      VideoMcpViewer
    }
  }

</script>